<template>
  <div class="c-value-toggler">
    <div
      class="c-value-button left"
      :class="{ disabled: val <= 1 || disabled }"
      :disabled="val <= 1 || disabled"
      @click="decrease()"
    >
      -
    </div>
    <input
      type="number"
      inputmode="numeric"
      :disabled="disabled"
      :class="{ disabled: disabled }"
      v-model="val"
      class="c-value-toggler-input"
      value="0"
    />
    <div class="c-value-button right" :class="{ disabled: disabled }" @click="increase()">+</div>
  </div>
</template>

<script>
export default {
  name: 'CInput',
  props: {
    value: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    val: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('update:value', newValue);
        this.$emit('change');
      },
    },
  },
  methods: {
    increase() {
      const value = parseInt(this.val, 10);
      if (value === 100) return;
      this.val = value + 1;
    },
    decrease() {
      const value = this.val;
      if (value === 1) return;
      this.val = value - 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.c-value-toggler {
  @apply inline-flex flex-row items-center;
}
.c-value-button {
  @apply w-8 h-8 outline-none text-center inline-flex flex-row items-center justify-center font-bold;

  &.left {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  &.right {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  &:focus,
  &:focus-within,
  &:focus-visible,
  &:active,
  &:target {
    background-color: #e7e7e7;
  }

  &.disabled,
  &:disabled {
    pointer-events: none;
    opacity: 0.25;
  }
}
.c-value-toggler-input {
  @apply w-8 h-8 outline-none text-center text-xs;
  border-radius: 4px;
}
</style>
